function m(d) {
  const {
    effect: s,
    swiper: e,
    on: r,
    setTranslate: f,
    setTransition: p,
    overwriteParams: n,
    perspective: o,
    recreateShadows: l,
    getEffectParams: c
  } = d;
  r("beforeInit", () => {
    if (e.params.effect !== s)
      return;
    e.classNames.push(`${e.params.containerModifierClass}${s}`), o && o() && e.classNames.push(`${e.params.containerModifierClass}3d`);
    const a = n ? n() : {};
    Object.assign(e.params, a), Object.assign(e.originalParams, a);
  }), r("setTranslate", () => {
    e.params.effect === s && f();
  }), r("setTransition", (a, i) => {
    e.params.effect === s && p(i);
  }), r("transitionEnd", () => {
    if (e.params.effect === s && l) {
      if (!c || !c().slideShadows)
        return;
      e.slides.forEach((a) => {
        a.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((i) => i.remove());
      }), l();
    }
  });
  let t;
  r("virtualUpdate", () => {
    e.params.effect === s && (e.slides.length || (t = !0), requestAnimationFrame(() => {
      t && e.slides && e.slides.length && (f(), t = !1);
    }));
  });
}
export {
  m as e
};
//# sourceMappingURL=effect-init.mjs.map
